import { procurementAPI } from "../../axios";

export const actions = {

    //Public Posts
    GetSinglePublicPostRfq(context, data){
        return procurementAPI.get(`PublicPostedRfq/${data}`);
    },
    CreatePublicPostRfq(context, data){
        return procurementAPI.post(`PublicPostedRfq/Create`, data);
    },
    UpdatePublicPostRfq(context, data){
        return procurementAPI.put(`PublicPostedRfq/Update/${data.id}`, data);
    },
    RemovePublicPostRfq(context, data){
        return procurementAPI.delete(`PublicPostedRfq/Remove/${data}`);
    },
    GetActivePublicPostRfq(){
        return procurementAPI.get(`PublicPostedRfq/Active`);
    },
    GetActivePublicPostRfqByCampus(context, data){
        return procurementAPI.get(`PublicPostedRfq/Filtered/Active/Campus/${data}`);
    },
    GetArchivePublicPostRfq(){
        return procurementAPI.get(`PublicPostedRfq/Expired`);
    },
    GetArchivePublicPostRfqByCampus(context, data){
        return procurementAPI.get(`PublicPostedRfq/Filtered/Expired/Campus/${data}`);
    },

    // Rfq File
    CreatePublicRfqFile(context, data){
        return procurementAPI.post(`PublicPostedRfqFile/Create`, data);
    },
    GetPublicRfqFile(context, data){
        return procurementAPI.get(`PublicPostedRfqFile/${data}`);
    },
}